import KeyValue from "components/KeyValue";
import Link from "ds/components/Link";
import { CLOUD_INTEGRATIONS } from "shared/CloudIntegration/types";
import { getCloudIntegrationUrl } from "shared/CloudIntegration/urls";
import { StackAzureIntegrationAttachment } from "types/generated";

type AttachCloudDetailsAzureFieldsType = {
  integration: StackAzureIntegrationAttachment;
};

const AttachCloudDetailsAzureFields = ({ integration }: AttachCloudDetailsAzureFieldsType) => {
  const integrationUrl = getCloudIntegrationUrl(
    CLOUD_INTEGRATIONS.Azure,
    integration.integrationId
  );

  return (
    <>
      <KeyValue name="Name">
        <Link href={integrationUrl} variant="secondary">
          {integration.integrationName}
        </Link>
      </KeyValue>
      <KeyValue name="Subscription ID">
        {integration.subscriptionId || integration.defaultSubscriptionId}
      </KeyValue>
    </>
  );
};

export default AttachCloudDetailsAzureFields;
